import { useEffect, useState } from 'react';

import { DotBricksLoading, Toast } from 'src/common/components';

import { fetchMetabaseDashboardToken } from '../api';
import { METABASE_SITE_URL } from '../constants';

export const Dashboard: React.FC = () => {
  const [iframeUrl, setIframeUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const dashboardId = '484';

  useEffect(() => {
    const generateIframeUrl = async (): Promise<void> => {
      try {
        setIsLoading(true);
        const metabaseDashboardToken = await fetchMetabaseDashboardToken(dashboardId);
        const metabaseIframeUrl = `${METABASE_SITE_URL}/embed/dashboard/${metabaseDashboardToken.dashboard_token}#theme=transparent&bordered=false&titled=true`;
        setIframeUrl(metabaseIframeUrl);
      } catch (err) {
        Toast.error('Error occurred during dashboard retrieve data');
      } finally {
        setIsLoading(false);
      }
    };
    void generateIframeUrl();
  }, []);

  if (isLoading) return <DotBricksLoading />;

  return (
    <div className="sm:px-6 lg:px-8 sm:pb-2 flex flex-col h-full pt-8 overflow-x-auto overflow-y-hidden">
      <iframe title="metabase-dashboard" src={iframeUrl} className="w-full h-screen" />
    </div>
  );
};
